module.exports = __webpack_public_path__ + "img/baziTitle.1d7b0f82.png";